<p-card class="p-card container">
  <h3 class="layout--text-center" i18n>Choisissez le plan du client</h3>

  <div class="layout--row layout--gap margin--bottom-large">
    <em-needs-reminder-section [needs]="needs" class="layout--full-width"></em-needs-reminder-section>
  </div>

  <em-selected-product-section [protection]="protection"></em-selected-product-section>
</p-card>
